import { useState } from 'react';
import Navbar from '@/components/Navbar';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Download } from 'lucide-react';
import { toast } from 'sonner';

const Settings = () => {
  return (
    <div className="min-h-screen bg-[#f1f5f9]">
      <Navbar />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-heading font-bold text-gray-900 mb-8" style={{ letterSpacing: '-0.02em' }}>
          Paramètres
        </h1>

        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle className="font-heading">Import de données</CardTitle>
              <CardDescription>
                Collectez automatiquement les entreprises des DOM-TOM depuis l'API INSEE
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div className="bg-accent/50 rounded-lg p-4">
                  <h4 className="font-semibold mb-2">Critères de collecte</h4>
                  <ul className="text-sm text-muted-foreground space-y-1">
                    <li>• Régions: Guadeloupe, Martinique, Guyane, Saint-Martin, Saint-Barthélemy</li>
                    <li>• Taille minimum: 20 employés</li>
                    <li>• Source: API INSEE Sirene (gratuite)</li>
                  </ul>
                </div>
                <p className="text-sm text-muted-foreground">
                  Utilisez le bouton "Import INSEE" sur le dashboard pour lancer une collecte.
                </p>
              </div>
            </CardContent>
            </Card>

          <Card>
            <CardHeader>
              <CardTitle className="font-heading">Extension LinkedIn</CardTitle>
              <CardDescription>
                Enrichissez vos contacts avec les données LinkedIn
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div className="bg-accent/50 rounded-lg p-4">
                  <h4 className="font-semibold mb-2">Télécharger l'extension</h4>
                  <p className="text-sm text-muted-foreground mb-4">
                    L'extension Chrome/Firefox vous permet d'extraire facilement les coordonnées des profils LinkedIn et de les ajouter directement à votre CRM.
                  </p>
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/api/download/extension`}
                    download
                  >
                    <Button className="gap-2 rounded-full" data-testid="download-extension-btn">
                      <Download className="h-4 w-4" />
                      Télécharger l'extension LinkedIn
                    </Button>
                  </a>
                </div>
                <div className="text-sm text-muted-foreground">
                  <p className="font-semibold mb-2">Instructions d'installation :</p>
                  <ol className="list-decimal list-inside space-y-1">
                    <li>Téléchargez le fichier ZIP de l'extension</li>
                    <li>Décompressez le fichier sur votre ordinateur</li>
                    <li>Ouvrez Chrome et allez dans Extensions (chrome://extensions/)</li>
                    <li>Activez le "Mode développeur"</li>
                    <li>Cliquez sur "Charger l'extension non empaquetée"</li>
                    <li>Sélectionnez le dossier décompressé</li>
                    <li>Configurez l'URL du CRM et votre token d'authentification</li>
                  </ol>
                  <p className="mt-3 text-primary font-medium">
                    📚 Guide complet : /app/TEST_EXTENSION_LINKEDIN.md
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="font-heading">Conformité RGPD</CardTitle>
              <CardDescription>
                Informations sur la protection des données
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="text-sm text-gray-700 space-y-3">
                <p>
                  <strong>Collecte de données :</strong> Les données collectées via l'API INSEE sont des informations publiques issues du registre des entreprises françaises.
                </p>
                <p>
                  <strong>Données personnelles :</strong> Les coordonnées des contacts (emails, téléphones) doivent être collectées avec le consentement des personnes concernées ou dans le cadre d'un intérêt légitime (prospection B2B).
                </p>
                <p>
                  <strong>Droits des personnes :</strong> Les contacts peuvent exercer leurs droits d'accès, de rectification et de suppression de leurs données en vous contactant directement.
                </p>
                <p>
                  <strong>Recommandation :</strong> Documentez la source de chaque contact et respectez les demandes de retrait.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Settings;